import React, {Component} from 'react';

import ModerationLoaded from '../../../../components/Moderations/ModerationsLoaded.jsx';
import ModerationLoading from '../../../../components/Moderations/ModerationsLoading.jsx';

import api from '../../../../../api.js';
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx";

export class History extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: []
    };
  }

  componentDidMount() {
    this.loadData(this.props.user);
  }

  componentDidUpdate = async(prevProps, prevState, prevContext) => {
    if(prevProps.user.id !== this.props.user.id) {
      await this.loadData(this.props.user);
    }
  };

  loadData = async(user) => {
    try {
      const moderations = await api.users.moderation.getAll({
        user: user.id
      });

      this.setState({
        loading: false,
        data: moderations.data,
      });
    } catch(e) {
      this.setState({loading: false})
    }
  };

  render() {
    return (
      <FreelancePage>
        <div className="step-general-pres p-5">
          <h2 className="text-center">Historique de modérations</h2>
          <p className="text-center mb-5">
            Historique des actions menées sur le profil du consultant.
          </p>
          {
            this.state.loading ? <ModerationLoading/> : <ModerationLoaded history={this.state.data} />
          }
        </div>
      </FreelancePage>
    );
  }
}

export default History;